import React from 'react';
import { cookiePolicySections } from '../content/cookiePolicySections';
import { privacyPolicySections } from '../content/privacyPolicySections';
import LegalDocumentPage from '../components/LegalDocumentPage';

const PrivacyPolicy: React.FC = () => (
  <LegalDocumentPage
    title="Privacy Policy"
    sections={[...privacyPolicySections, ...cookiePolicySections]}
  />
);

export default PrivacyPolicy;
